import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

let { lambda } = window.app;

const Unsubscribe = () => {
    const [searchParams] = useSearchParams();
    const visitorid = searchParams.get("visitorid");
    const appname   = searchParams.get("appname") || window.app?.appname;

    const [optOutEmail, setOptOutEmail] = useState(false);
    const [optOutSms,   setOptOutSms]   = useState(false);
    const [prefLoading, setPrefLoading] = useState(true);
    const [submitted,   setSubmitted]   = useState(false);
    const [loading,     setLoading]     = useState(false);
    const [error,       setError]       = useState("");
    const [visitorName, setVisitorName] = useState("");
    const [image,       setImg]         = useState("");

    useEffect(() => {
        if (window.site?.common?.imagesCDN) {
            setImg(window.site.common.imagesCDN);
        } else {
            setTimeout(() => {
                if (window.site?.common?.imagesCDN) setImg(window.site.common.imagesCDN);
            }, 1000);
        }

        if (visitorid && appname) {
            axios.post(`${lambda}/getVisitor?appname=${appname}&visitorid=${encodeURIComponent(visitorid)}`)
                .then(res => {
                    const visitor = res?.data?.result?.[0];
                    if (visitor?.name) setVisitorName(visitor.name);
                    // Pre-check whichever notification channels the visitor has enabled
                    const prefs = visitor?.notificationPreferences || {};
                    setOptOutEmail(prefs.email === true);
                    setOptOutSms(prefs.sms === true);
                })
                .catch(() => {})
                .finally(() => setPrefLoading(false));
        } else {
            setPrefLoading(false);
        }
    }, []);

    const handleSubmit = async () => {
        if (!visitorid) {
            setError("Invalid unsubscribe link. Please contact support.");
            return;
        }
        setLoading(true);
        setError("");
        try {
            await axios.post(
                `${lambda}/optout?appname=${encodeURIComponent(appname)}&visitorid=${encodeURIComponent(visitorid)}`,
                {
                    notificationPreferences: {
                        email: optOutEmail,
                        sms:   optOutSms
                    }
                }
            );
            setSubmitted(true);
        } catch (err) {
            setError("Something went wrong. Please try again or contact support.");
        }
        setLoading(false);
    };

    const logo = "https://d13pnvf7i9kk1t.cloudfront.net/spotsaverStaging/images/web/logo-dark.png";

    if (submitted) {
        const channels = [optOutEmail && "email", optOutSms && "SMS"].filter(Boolean);
        return (
            <div style={styles.page}>
                <div style={styles.card}>
                    <img src={logo} alt="SpotSaver" style={styles.logo} onError={e => { e.target.style.display = 'none'; }} />
                    <span className="material-icons" style={{ fontSize: 56, color: '#198754', marginBottom: 8 }}>check_circle</span>
                    <h2 style={styles.heading}>Preferences Updated</h2>
                    <p style={styles.body}>
                        Your communication preferences have been saved.<br />
                        Opt-out requests are processed immediately.
                    </p>
                    {channels.length > 0 && (
                        <p style={{ ...styles.body, color: '#888', fontSize: 13, marginTop: 8 }}>
                            You have unsubscribed sucessfully.
                        </p>
                    )}
                    {/* <p style={styles.note}>
                        You may still receive transactional messages related to your bookings and account activity.
                    </p> */}
                </div>
            </div>
        );
    }

    if (prefLoading) {
        return (
            <div style={styles.page}>
                <div style={styles.card}>
                    <img src={logo} alt="SpotSaver" style={styles.logo} onError={e => { e.target.style.display = 'none'; }} />
                    <span className="material-icons" style={{ fontSize: 40, color: '#aaa', animation: 'spin 1s linear infinite' }}>sync</span>
                    <p style={{ color: '#888', marginTop: 12 }}>Loading your preferences…</p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <img src={logo} alt="SpotSaver" style={styles.logo} onError={e => { e.target.style.display = 'none'; }} />

                {visitorName ? (
                    <p style={{ fontWeight: 600, marginBottom: 4 }}>Hello {visitorName},</p>
                ) : null}

                <h2 style={styles.heading}>Update Your Notification Preferences</h2>
                <p style={styles.body}>
                    Select which types of notifications you would like to unsubscribe from.
                </p>

                <div style={styles.options}>
                    <label style={styles.optionRow}>
                        <input
                            type="checkbox"
                            checked={optOutEmail}
                            onChange={e => setOptOutEmail(e.target.checked)}
                            style={styles.checkbox}
                        />
                        <span>
                            <strong>Email notifications</strong><br />
                            <span style={{ fontSize: 13, color: '#666' }}>Unsubscribe from promotional and alert emails</span>
                        </span>
                    </label>

                    <label style={styles.optionRow}>
                        <input
                            type="checkbox"
                            checked={optOutSms}
                            onChange={e => setOptOutSms(e.target.checked)}
                            style={styles.checkbox}
                        />
                        <span>
                            <strong>SMS notifications</strong><br />
                            <span style={{ fontSize: 13, color: '#666' }}>Unsubscribe from promotional and alert text messages</span>
                        </span>
                    </label>
                </div>

                {error && (
                    <p style={{ color: '#dc3545', fontSize: 13, marginBottom: 12 }}>{error}</p>
                )}

                <button
                    className="fill-btn-style"
                    onClick={handleSubmit}
                    disabled={loading}
                    style={{ marginTop: 8, opacity: loading ? 0.7 : 1 }}
                >
                    {loading ? "Saving..." : "Update Preferences"}
                </button>

                <p style={styles.note}>
                    Opt-out requests are processed immediately. You may still receive transactional
                    messages related to your bookings and account activity.
                </p>
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f6f7fb",
        padding: "40px 16px",
        fontFamily: "inherit"
    },
    card: {
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
        padding: "40px 36px",
        maxWidth: 480,
        width: "100%",
        textAlign: "center"
    },
    logo: {
        maxHeight: 48,
        marginBottom: 24,
        objectFit: "contain"
    },
    heading: {
        fontSize: 20,
        fontWeight: 700,
        margin: "12px 0 8px"
    },
    body: {
        color: "#555",
        fontSize: 14,
        lineHeight: 1.6,
        marginBottom: 20
    },
    options: {
        textAlign: "left",
        margin: "20px 0"
    },
    optionRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        cursor: "pointer",
        marginBottom: 16,
        padding: "12px 14px",
        border: "1px solid #e8e8e8",
        borderRadius: 8,
        background: "#fafafa"
    },
    checkbox: {
        width: 18,
        height: 18,
        marginTop: 2,
        accentColor: "var(--highlight, #6c2bd9)",
        flexShrink: 0,
        cursor: "pointer"
    },
    note: {
        fontSize: 11,
        color: "#aaa",
        marginTop: 20,
        lineHeight: 1.5
    }
};

export default Unsubscribe;
